import React from "react"
import { Flex, Text, Heading } from "@chakra-ui/react"

export default function StatsItem({ value, stat, copy }) {
  return (
    <Flex flexDirection="column" alignItems="center" maxWidth="390px" mx="auto">
      <Heading as="span" size="5xl" color="primary.200" fontWeight="semibold">
        {value}
      </Heading>
      <Text as="div" textAlign="center" w="full">
        {stat}
      </Text>
      <Text mt={6} textAlign="center">
        {copy}
      </Text>
    </Flex>
  )
}
